/**
 * Parse locations XML and make them unique
 * @param {NodeList}
 * @returns {Array}
 */
const filterLocations = nodeList => {

  function filterNodeList(list) {
    const experiencesHash = {};
    const locationHash = {};
    const tagsHash = {};

    list.map((item, index) => {

      const city = item.city;
      const content = item.content;
      const country = item.country_name;
      const lat = item.latitude;
      const lng = item.longitude;
      const luxary_level = item.luxary_level;
      const phg_id = item.phg_id;
      const property_name = item.property_name;
      const state = item.state;
      const state_name = item.state_name; 
      const zip = item.zip;
      const address1 = item.address1;
      const property_link = item.propertyLink;
      const special_character = item.special_character;
      const experiences = item.experiences.split(',');
      const tags = item.tags;

      function hasState() {
        if (state_name === '' || state_name === 'Other') {
          return ',';
        }

        return `${state_name},`;
      }

      function locationItem({ value, data }) {
        if (value === '' || value === 'Other') return;

        if (!locationHash.hasOwnProperty(value)) {
          locationHash[value] = {
            country,
            description: content,
            experiences,
            lat,
            lng,
            luxary_level,
            phg_id,
            city,
            state,
            state_name,
            tags,
            value,
            index,
            zip,
            address1,
            property_link,
            special_character,
            code: item.code.replace(/(-*-)/g, ' ').replace(/\b[a-z](?=[a-z]{2})/g, letter => letter.toUpperCase())
          };

          if (data) {
            locationHash[value].data = {
              location: `${city}, ${hasState()} ${country}`
            };
          }
        }
      }

      // property_name
      locationItem({
        value: property_name,
        data: true
      });
      
      // city
      locationItem({
        value: `${city}, ${hasState()} ${country}`
      });

      // state_name
      locationItem({ value: state_name });

      // country
      locationItem({ value: country });
    });

    // define all unique locations
    let location;
    let locations = [];

    for (location in locationHash) {
      if (!locationHash[location].data) {
        locations.push(locationHash[location]);
      }
    }

    // define all unique hotels
    let hotel;
    let hotels = [];

    for (hotel in locationHash) {
      if (locationHash[hotel].data) {
        hotels.push(locationHash[hotel]);
      }
    }

    // define all unique countries
    const countries = {};

    hotels.map(hotel => {
      if (!countries[hotel.country]) {
        countries[hotel.country] = [];
      }
    });

    // group hotels by country
    hotels.map(hotel => {
      if (countries[hotel.country]) {
        countries[hotel.country].push(hotel);
      }
    });

    // add index to hotel by country for google maps pins
    Object.keys(countries).map(country => {
      countries[country].map((hotel, index) => {
        hotel.countryIndex = (index + 1).toString();
      });
    });

    //Add unique index to the hotel 
    let indexScope = 0; 
    Object.keys(countries).map(country => {
      indexScope+= 1;
      countries[country].map((hotel, index) => {
        if(index !== 0) {
          indexScope += 1;
        }
        hotel.index = (indexScope).toString();
      });
    });  

    locations = locations.sort((a, b) => a.value.length - b.value.length);
    hotels = hotels.sort((a, b) => {
      const toLower = str => str.toLowerCase();

      if (toLower(a.value) > toLower(b.value)) {
        return 1;
      } else if (toLower(a.value) < toLower(b.value)) {
        return -1;
      }

      return 0;
    });
    
    const allPlaces = locations.concat(hotels);
    
    // define all unique experiences and tags
    allPlaces.map(place => {
      place.tags.map(tag => {
        if (!tagsHash[tag.name]) {
          tagsHash[tag.name] = tag;
        }
      });

      place.experiences.map(experience => {
        if (!experiencesHash[experience]) {
          experiencesHash[experience] = experience;
        }
      });
    });

    const allPlacesWidget = allPlaces;

    let experience;
    const experiences = [];

    for (experience in experiencesHash) {
      experiences.push(experience);
    }

    let tag;
    const tags = [];

    for (tag in tagsHash) {
      tags.push(tagsHash[tag]);
    }

    return {
      allPlaces,
      experiences,
      hotels,
      locations,
      tags,
      allPlacesWidget
    }
  }

  const {
    allPlaces,
    experiences,
    hotels,
    locations,
    tags
  } = filterNodeList(nodeList.home);

  const { 
    allPlacesWidget 
  } = filterNodeList(nodeList.widget);

  return {
    allPlaces,
    experiences,
    hotels,
    locations,
    tags,
    allPlacesWidget
  }
};

export default filterLocations;
